import React from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import { useDisclosure } from "@chakra-ui/react";

import Footer from "components/Footer/Footer.js";

import Navbar from "components/Navbars/Navbar";
import SidebarTW from "components/Sidebar/SidebarTW";

import dynamicRoutes from "dynamicRoutes.js";
import SidebarModal from "components/SidebarModal/SidebarModal";

function Dashboard(props) {
  const routes = dynamicRoutes["user"];
  const [backgroundColor, setBackgroundColor] = React.useState("black");
  const [activeColor, setActiveColor] = React.useState("info");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const location = useLocation();

  const pattern = /^\/user\/suppliers\/[a-f0-9-]+$/;

  const is_at_supplier_detail = pattern.test(location.pathname);

  const openSmallSidebar = () => {
    onOpen();
  };

  return (
    <div className="w-screen  ">
      <SidebarModal isOpen={isOpen} onClose={onClose} routes={routes} />
      <Navbar {...props} className="z-50" openSmallSidebar={openSmallSidebar} />
      <div className="w-full h-full flex flex-row  ">
        {!is_at_supplier_detail && (
          <SidebarTW
            {...props}
            routes={routes}
            bgColor={backgroundColor}
            activeColor={activeColor}
          />
        )}
        <div
          style={{ height: "calc(100vh - 4rem)" }}
          className="w-full  ml-2 lg:ml-6 pt-6  overflow-y-auto  pr-2 lg:pr-12  "
        >
          <Routes>
            {routes.map((prop, key) => {
              return (
                <Route
                  path={prop.path}
                  element={prop.component}
                  key={key}
                  exact
                />
              );
            })}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
